<template>
    <div class="conmon-top tabs-class">
        <el-row>
            <el-tabs class="setting-tabs" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="签到设置" name="first">
                  <el-row class="introduce-content ovf-hd" style="padding:15px;">
                      <el-row class="configure">
                          <el-col>
                              <i class="el-icon-document" style="margin-left:17px"></i>
                              签到配置:
                          </el-col>
                      </el-row>
                      <el-row>
                          <el-col style="text-align:center">
                              <el-upload
                                      multiple
                                      :limit="1"
                                      v-loading="loading"
                                      class="acivity-uploader sign-manage"
                                      name="file_upload"
                                      :action="uploadURL"
                                      :show-file-list="true"
                                      :on-success="handleAvatarSuccess"
                                      :before-upload="beforeAvatarUpload">
                                  <div v-if="bgimg" class="upload_img">
                                      <img v-if="bgimg" :src="bgimg" class="acivity">
                                      <div class="modify_img">点击修改</div>
                                  </div>
                                  <img v-else src="../../assets/images/Group.png" class="default-acivity">
                                  <div slot="tip" class="el-upload__tip">建议尺寸750*1334(必填)</div>
                              </el-upload>
                          </el-col>
                      </el-row>
                  </el-row>
                  <el-row style="margin:0 24px;" class="signIn-tips">
                      <el-col>
                          <el-alert
                                  title="类型为实物时，请填写实物编码；类型为积分时，请填写积分分值；
                                  类型为优惠券或游戏时，请填写优惠券或游戏的链接地址。"
                                  type="warning">
                          </el-alert>
                      </el-col>
                  </el-row>
                  <el-row class="search-title common-table-top" style="border-bottom: 1px solid #ebeef5;">
                      <el-col :span="4" style="text-align: left;">
                          <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right: 6px"></i>
                          <span class="order-list-search-span">数据列表</span>
                      </el-col>
                      <el-col :span="20" class="text-align-right">
                          <el-button type="primary" size="small" @click="addOne" class="new-add"  >新增</el-button>
                      </el-col>
                  </el-row>
                  <el-row  class="signIn-setting table-first-style">
                        <el-col>
                            <el-table ref="multipleTable"
                                      :data="addData"
                                      v-loading="loadSetting"
                                      class="table">
                                <el-table-column prop="days" label="连续签到天数"
                                  width="130">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.days" type="number" min=0 placeholder="请输入连续签到天数" class="search-list-input" style="margin-left: 0;margin-right: 0" @change="scope.row.days=Math.abs(scope.row.days)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="赠送类型" prop="type" width="220">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.type" placeholder="请选择赠送类型" class="search-list-input" style="margin-left: 0;">
                                            <el-option
                                                    v-for="item in typeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" label="赠送奖品">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.title" placeholder="输入赠送奖励" class="search-list-input" style="margin-left: 0;margin-right: 0"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="code" label="奖品名称">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.code"  placeholder="请输入奖励说明" class="search-list-input" style="margin-left: 0;margin-right: 0"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="100" style="display: flex;justify-content: center">
                                    <template slot-scope="scope">
                                        <div class="op-link" style="margin-top: 8px">
                                            <el-button type="text" @click.native.prevent="deleteOne(scope.$index, addData)" style="color: #4882ff;font-size: 14px">删除</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                  <el-row class="table">
                       <el-col :span="24" style="text-align: right;margin-top: 10px">
                          <el-button type="primary" class="confirm-btn signIn-btn" @click="saveSignInSetting" style="float:right;margin-right:30px;border-radius:4px">保 存</el-button>
                    </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="签到统计" name="second">
                  <el-row class="search-title common-table-top">
                        <el-col :span="4" style="text-align: left;">
                            <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right: 6px"></i>
                            <span class="order-list-search-span">数据列表</span>
                        </el-col>
                  </el-row>
                <el-row class="import-data-title table-first-style">
                    <el-table
                            :data="tableData"
                            v-loading="loadCount"
                            class="table">
                        <!-- <el-table-column
                                prop="avatar"
                                label="头像">
                            <template slot-scope="scope">
                                <img :src="scope.row.avatar" class="table-img">
                            </template>
                        </el-table-column> -->
                        <el-table-column
                                prop="realname"
                                label="会员">
                            <template slot-scope="scope">
                                <img :src="scope.row.avatar" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%;float:left;margin-right:10px;">
                                <div style="line-height: 32px;">{{ scope.row.realname }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="第一次签到">
                            <template slot-scope="scope">
                                {{ scope.row.first_checkin_time | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="最后一次签到">
                            <template slot-scope="scope">
                                {{ scope.row.last_checkin_time | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="daily_checkin"
                                label="连续签到次数">
                        </el-table-column>
                        <el-table-column
                                prop="checkin_all_day"
                                label="最高签到次数">
                        </el-table-column>
                        <el-table-column
                                prop="checkin_integral_total"
                                label="奖励总积分">
                        </el-table-column>
                    </el-table>
                    <div class="table-foot">
                        <el-pagination
                                class="table-foot-pagination"
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-size="limit"
                                layout="total, prev, pager, next, jumper"
                                :total="totalCount">
                        </el-pagination>
                    </div>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="签到订单" name="third">
                  <div class="page-content conmon-top">
                      <div class="base-input ovf-hd" style="margin-bottom: 10px;">
                          <el-row class="search-title" style="background-color: #fafafa">
                              <el-col :span="4" class="search-nav-left">
                                  <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;"></i>
                                  <span class="order-list-search-span">筛选查询</span>
                              </el-col>
                              <el-col :span="20" class="search-nav-right">
                                  <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
                                  <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                                  <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                                  <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
                                  <el-button class="search-btn-new" type="primary" size="small" @click="searchOrderData">查询</el-button>
                              </el-col>
                          </el-row>
                          <el-collapse-transition>
                              <div v-show="hide" class="search-content common-search-formtype">
                                  <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
                                      <el-form-item label="状态:">
                                          <el-select v-model="formInlineTmp.shipping_status" placeholder="请选择">
                                              <el-option
                                                      v-for="item in statusOptions"
                                                      :key="item.value"
                                                      :label="item.label"
                                                      :value="item.value">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item label="类型:">
                                          <el-select v-model="formInlineTmp.gift_type" placeholder="请选择">
                                              <el-option
                                                      v-for="item in gifttypeOptions"
                                                      :key="item.value"
                                                      :label="item.label"
                                                      :value="item.value">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                  </el-form>
                              </div>
                          </el-collapse-transition>
                      </div>
                      <el-row class="search-title common-table-top" style="padding-right:0">
                          <el-col :span="4" style="text-align: left;">
                              <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right: 6px"></i>
                              <span class="order-list-search-span">数据列表</span>
                          </el-col>
                          <el-col :span="20" class="text-align-right">
                              <el-button type="primary" class="add-btn" style="float: right;"
                              @click="signInSendSync">发货同步</el-button>
                              <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="signInOrderSync">订单同步</el-button>
                              <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="exporeAction">Excel导出</el-button>
                          </el-col>
                      </el-row>
                      <el-row class="import-data-title table-first-style">
                          <el-table
                                  :data="signOrderData"
                                  v-loading="loadOrder"
                                  class="table">
                              <el-table-column
                                      prop="order_num"
                                      width="130"
                                      label="订单编号"
                                      >
                              </el-table-column>
                              <el-table-column
                                      width="160"
                                      prop="vip_card"
                                      label="会员编号">
                              </el-table-column>
                              <el-table-column
                                      width="80"
                                      prop="consignee_name"
                                      label="姓名">
                              </el-table-column>
                              <el-table-column
                                      width="100"
                                      prop="consignee_number"
                                      label="手机号">
                              </el-table-column>
                              <el-table-column
                                      prop=""
                                      label="收货地址">
                                  <template slot-scope="scope">
                                      <span>{{ scope.row.consignee_province }}- {{ scope.row.consignee_city }}-{{ scope.row.consignee_county }}</span>
                                  </template>
                              </el-table-column>
                              <el-table-column
                                      width="90"
                                      label="类型">
                                  <template slot-scope="scope">
                                      <div v-if="scope.row.gift_type === 1">积分</div>
                                      <div v-if="scope.row.gift_type === 2">优惠券</div>
                                      <div v-if="scope.row.gift_type === 3">实物</div>
                                      <div v-if="scope.row.gift_type === 4">游戏</div>
                                  </template>
                              </el-table-column>
                              <el-table-column
                                      prop="gift"
                                      label="赠送奖品">
                              </el-table-column>
                              <el-table-column
                                      prop="gift_content"
                                      label="奖品名称">
                              </el-table-column>
                              <el-table-column
                                      prop="create_time"
                                      width="135"
                                      label="创建时间">
                                  <template slot-scope="scope">
                                      {{scope.row.create_time | formatDate}}
                                  </template>
                              </el-table-column>
                              <el-table-column
                                      width="90"
                                      label="发货状态">
                                  <template slot-scope="scope">
                                      <div v-if="scope.row.shipping_status === -1">发货失败</div>
                                      <div v-if="scope.row.shipping_status === 0">未发货</div>
                                      <div v-if="scope.row.shipping_status === 1">发货中</div>
                                      <div v-if="scope.row.shipping_status === 2">已发货</div>
                                  </template>
                              </el-table-column>
                              <el-table-column
                                      prop="mail_no"
                                      width="120"
                                      label="快递单号">
                              </el-table-column>
                          </el-table>
                          <div class="table-foot">
                              <el-pagination
                                      class="table-foot-pagination"
                                      background
                                      @size-change="handleSizeChange2"
                                      @current-change="handleCurrentChange2"
                                      :page-size="limit"
                                      layout="total, prev, pager, next, jumper"
                                      :total="totalCount2">
                              </el-pagination>
                          </div>
                      </el-row>
                  </div>
              </el-tab-pane>
        </el-tabs>
        </el-row>
    </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getSignInList, getSignInLogList, addSignInSettingList, getSignInOrderList, signInSendSyncData, SignInOrderSyncData, exporeSignInOrder } from '@/api/customer.js'
export default {
  name: 'signInManage',
  data () {
    return {
      loadSetting: true,
      loadCount: true,
      loadOrder: true,
      hide: true,
      id: '',
      text: '',
      activeName: 'first',
      addData: [],
      tableData: [],
      signOrderData: [],
      search: {
        type: ''
      },
      formInline: {
        shipping_status: '',
        gift_type: ''
      },
      formInlineTmp: {},
      typeOptions: [
        {
          value: '1',
          label: '积分'
        },
        {
          value: '2',
          label: '优惠券'
        },
        {
          value: '3',
          label: '实物'
        },
        {
          value: '4',
          label: '游戏'
        }
      ],
      gifttypeOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '积分'
        },
        {
          value: '2',
          label: '优惠券'
        },
        {
          value: '3',
          label: '实物'
        }
      ],
      statusOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '-1',
          label: '发货失败'
        },
        {
          value: '0',
          label: '未发货'
        },
        {
          value: '1',
          label: '发货中'
        },
        {
          value: '2',
          label: '已发货'
        }
      ],
      totalCount: 0,
      totalCount2: 0,
      page: 1,
      limit: 10,
      loading: false,
      title: '',
      rules: {
        type: [
          { required: true, message: '请选择奖励类型', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写奖励内容', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写赠送奖励说明', trigger: 'blur' }
        ],
        days: [
          { required: true, message: '请填写连续签到天数', trigger: 'blur' }
        ]
      },
      bgimg: '',
      signInSettingList: {
        id: 0,
        bgimg: '',
        days: '',
        code: '',
        type: '',
        title: ''
      }
    }
  },
  methods: {
    searchOrderData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getOrderData()
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getSignInSettingData()
      this.getSignInLogData()
      this.getOrderData()
    },
    // 点击增加一行
    addOne() {
      let i = this.addData.length
      this.addData.push({
        days: '',
        type: '',
        code: '',
        title: '',
        integral: ''
      })
    },
    // 删除一行
    deleteOne(index, rows) {
      rows.splice(index, 1)
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getSignInLogData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getSignInLogData()
    },
    // 处理订单分页
    handleSizeChange2(val) {
      this.limit = val
      this.getOrderData()
    },
    handleCurrentChange2(page) {
      this.page = page
      this.getOrderData()
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.bgimg = res.data.path
      this.signInSettingList.bgimg = res.data.path
      this.loading = false
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      this.loading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt8M = file.size / 1024 / 1024 < 8
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt8M) {
        _g.toastMsg('error', '上传头像图片大小不能超过 8MB!')
        this.loading = false
      }
      return (isJPG && isLt8M) || (isPNG && isLt8M)
    },
    // 订单excel导出
    exporeAction() {
      exporeSignInOrder(this.formInline).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 签到设置验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 签到设置保存
    saveSignInSetting() {
      let type = []
      let days = []
      let code = []
      let title = []
      for (let item of this.addData) {
        type.push(item.type)
        days.push(item.days)
        code.push(item.code)
        title.push(item.title)
      }
      this.signInSettingList.type = type
      this.signInSettingList.days = days
      this.signInSettingList.code = code
      this.signInSettingList.title = title
      this.signInSettingList.bgimg = this.bgimg
      addSignInSettingList(this.signInSettingList).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '提交成功')
          this.getSignInSettingData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取签到设置列表数据
    getSignInSettingData() {
      this.loadSetting = true
      getSignInList().then(res => {
        if (res.data.code === 0) {
          if (res.data.data.info.id) {
            this.signInSettingList.id = res.data.data.info.id
            this.bgimg = res.data.data.info.bgimg
          }
          this.addData = res.data.data.guize
          this.totalCount = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.loadSet()
    },
    // 获取签到统计列表数据
    getSignInLogData() {
      this.loadCount = true
      getSignInLogList(this.page, this.limit).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.loadCountData()
    },
    // 获取订单列表数据
    getOrderData() {
      this.loadOrder = true
      getSignInOrderList(this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.signOrderData = res.data.data.list
          this.totalCount2 = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.loadOrderData()
      })
    },
    // 发货同步
    signInSendSync() {
      signInSendSyncData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 订单同步
    signInOrderSync() {
      SignInOrderSyncData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 数据加载时的动画
    loadSet() {
      setTimeout(() => {
        this.loadSetting = false
      }, 500)
    },
    loadCountData() {
      setTimeout(() => {
        this.loadCount = false
      }, 500)
    },
    loadOrderData() {
      setTimeout(() => {
        this.loadOrder = false
      }, 500)
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getSignInSettingData()
    this.getSignInLogData()
    this.getOrderData()
  }
}
</script>

<style scoped>
    .upload_img {
        position:relative;
    }
    .upload_img:hover .modify_img{
        display: inline-block;
    }
    .modify_img{
        position: absolute;
        height: 100%;
        width: 100%;
        background: #000;
        opacity: 0.6;
        display: none;
        top: 0;
        left: 0;
        color: #fff;
        font-size: 18px;
        line-height: 623px;
    }
    .el-alert__closebtn {
         display: none;
     }
    .configure {
        text-align:left;
        font-size:14px;
        font-weight:400;
        color:#333;
    }
    .introduce-content {
        margin-top: 10px;
        background: #fff;
        border: 1px solid #ebebeb;
    }
    .introduce-content ul {
        padding-left: 20px;
    }
    .introduce-content li {
        height: 25px;
        font-size: 14px;
        color: #666;
    }
    .acivity-uploader {
        margin-top: 20px;
    }
    .acivity-uploader .el-upload {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .acivity-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .acivity-uploader-icon {
        border: 1px dashed #d9d9d9;
        font-size: 28px;
        color: #8c939d;
        width: 208px;
        height: 208px;
        line-height: 208px;
        text-align: center;
    }
    .acivity {
        width: 350px;
        height: 623px;
        display: block;
    }
    .new-add {
        margin:10px 32px 10px 0;
        position:absolute;
        top:0;
        right:0;
        z-index: 100;
    }
    .setting-tabs .el-tabs__header {
      margin-bottom: 0px!important;
    }
</style>
